export const WINEFO_URL = 'https://www.winefo.eu';
export const WINEFO_BLOG = 'https://www.Winefo.eu/blog';
export const TERMS_AND_CONDITIONS =
  'https://www.winefo.eu/terms-conditions-winefo-platform';
export const PRIVACY_POLICY =
  'https://www.winefo.eu/privacy-policy-winefo-platform';
